import RetailImg from "assets/generated_images/stories-pharmacist.png";


export const stories = [
  {
    category: "BPO Services",
    title: "Whole team for online Pharmaceutical information",
    description:
      "Our client for more than 10 years, UK’s leading provider of online pharmaceutical information.",
    image: "/assets/optimized/stories-pharmacist",
    slug: "pharmaceutical-information-bpo",
    content: `
      <p>
        Our client for more than 10 years, UK’s leading provider of online pharmaceutical information, major provider to NHS Choices, publishing details of all prescribed and OTC drugs.
      </p>

      <p>
        Initially tasked with data administration tasks processing Summary of Product Characteristics (SPC’s) and Patient Information Leaflets (PIL’s) the team soon extended to include fully trained pharmacists to undertake comprehensive proof reading prior to information appearing online.
      </p>

      <p>
        The quality of service coupled with flexibility and cost efficiencies prompted our client to seek our help with providing web developers and quality assurance personnel.
      </p>

      <p>
       The entire team, now numbering 20 personnel, are an integral and invaluable part of our client’s operations.
      </p>

    `,
  },
  {
    category: "Web Development",
    title: "Speed Application Development Up with AI",
    description:
      "Using AI-assisted workflows to accelerate software delivery across complex systems.",
    image: "/assets/optimized/stories-ai-developer",
    slug: "ai-driven-development",
    content: `
        <p className="py-10">
            With over 25 years of web development we have managed to go through all of the obstacles as well as efficiencies of the whole software development life cycle from planning, requirements gathering, design, development, testing, deployment, and maintenance and eventual support. From coding thru ancient notepad to integrated development environment (IDEs) to internet development environments and advancement thru automation brought about by AI, we have seen how to deliver fast and reusable applications that fit all kinds of budget.
        </p>

        <p>
            We've recently handled the development and support for UK's No. 1 competition, prize and free stuff site with 6.2M registered members averaging 38K unique activities weekly.
        </p>

        <p>
            Tasks included studying archaic legacy system, replicating 3rd party data validation thru APIs and doing complex data migration from topsy-turvy table structures. Current team now handles enhancements, maintenance, support and AI integration.
        </p>

    `,
  },
  {
    category: "Address Intelligence",
    title: "99.8% Address Accuracy Achieved",
    description:
      "Replacing unreliable address lookups with a robust, enterprise-grade solution.",
    image: "/assets/optimized/stories-eaf",
    slug: "address-accuracy-improvement",
    content: `
      <p>
        Specialising in the mother and baby sector our client had used an address look-up service, but it was prone to interruptions and lack of advance notifications regarding number of look-up credits still available.
      </p>

      <p>
        With our diligent client care protocols this ensured zero service downtime. In addition the cost savings, compared to previous supplier, was gratefully received.
      </p>
      <p>
        Our new version of Address Finder provides further options including Unique Property Reference Number (UPRN), exact X and Y geo co-ordinates and estimated property value.
      </p>
    `,
  },
  {
    category: "Web Development",
    title: "DLG PDV",
    description:
      "",
    image: "/assets/optimized/pdv-dlg",
     logo: "/assets/optimized/dlg-case",
    slug: "dlg-pdv",
    content: `
      <h3>Providing Outsourced Knowledge Resources for your non-core competencies</h3>
      <p>DLG and PDV are consumer marketing data specialists and the UK's largest provider of consumer lifestyle data. They help their clients achieve optimum campaign results from the provision of leads and data with a focus on quality, recency and relevance.  </p>
      <h3>The Challenge</h3>
      <p>DLG manages a number of survey programs online via systems that are hosted on multiple remote servers that need to be managed and aligned with the business goals of lead generation. The challenge was to outsource the management of these online survey systems and server configurations while at the same time providing DLG with web development skills and resource for new web and mobile friendly projects.</p>
      <h3>Our Solution</h3>
      <ul>
        <li>Review of current set-upwhich involved systems administration and web development skills matching</li>
        <li>Creation of a Manila based team to support and administer current and online survey systems and servers.</li>
        <li>Provision for flexibility in terms of adhoc development work by highly specialised developers.</li>
      </ul>
      <h3>The Result</h3>
      <ul>
        <li>Successful configuration, maintenance and development support for 6 Live ColdFusion Servers, 8 Live CF Web Applications and 2 Databases supporting all CF based surveys. </li>
        <li>Successful configuration, maintenance and development support for 13 Live .Net Web Applications and 3 Live SQL Databases on 4 Windows Servers,</li>
        <li>Scalable standby resource for any projects involving Microsoft .Net and Cold Fusion development work.</li>
      </ul>
    `,
  },
   {
    category: "Web Development",
    title: "Emma's Diary",
    description:
      "",
    image: "/assets/optimized/sp01databasemanagement",
    logo: "/assets/optimized/emma-logo",
    slug: "emmas-diary",
    content: `
      <h3>Providing Outsourced Knowledge Resources for your non-core competencies</h3>
      <p>Emma’s Diary is the UK’s number one website for expectant mothers and mothers of young baby’s.  In addition to the website procurement, details of expectant mothers are also collected from GP’s surgeries. Key information on millions of individuals, including lifestyle, demographic and purchasing preferences is compiled.</p>
      <h3>The Challenge</h3>
      <ul>
        <li>Updates of the database to be reduced from the 6 working days, incumbent supplier was taking, to a much lesser t/a</li>
        <li>An easy to use online tool to interrogate the database that could incorporate drive times, analysis and profiling functionality</li>
        <li>A more cost effective solution  for ongoing maintenance but most particularly for any bespoke requests</li>
      </ul>
      <h3>Our Solution</h3>
      <ul>
        <li>Routines to screen all incoming  feeds for data correctness and validity</li>
        <li>A complete re-design of the underlying SQL database</li>
        <li>Development of fully automated  update routines, processes and reporting</li>
        <li>Online access to the database for Emma’s Diary personnel using FastStats with the  appropriate modules</li>
      </ul>
      <h3>The Result</h3>
      <ul>
        <li>Database update turnaround times reduced by over 80% to just 24 hours!</li>
        <li>Ability to fulfill more client requests in a shorter time, providing increased revenue within just a couple of days training</li>
        <li>FastStats allows new Emma’s Diary personnel to undertake tasks.</li>
        <li>YonY cost savings in excess of 60% when compared to previous supplier.</div>
      </ul>
    `,
  },
   {
    category: "Web Development",
    title: "Media Watch",
    description:
      "",
    image: "/assets/optimized/stories-rha",
    logo: "/assets/optimized/mediawatch-case",
    slug: "media-watch",
    content: `
      <h3>Providing Outsourced Knowledge Resources for your non-core competencies</h3>
      <p>RHA Media is a company specialising in the nonprofit sector. They enable Charities to optimise their donor communications by monitoring competitor direct marketing activity across multiple channels.</p>
      <h3>The Challenge</h3>
      <p>RHA Media envisioned launching an online donor communications monitoring tool and looked at an outsourced solution which fits into a budget of a start up company, but has the history and expertise to deliver a database driven web application under a tight 8 week schedule.</p>
      <h3>Our Solution</h3>
      <ul>
        <li>Review literature and become accustomed with charity sector specific terms and processes.</li>
        <li>eview and analyse solution and propose how to develop the online monitoring tool for charities. </li>
        <li>evelop, configure and maintain solution including user acceptance until hand over. </li>
      </ul>
      <h3>The Result</h3>
      <ul>
        <li>On time, on budget delivery of a .Net database driven web application  compatible for all major desktop browsers with future provision for compatibility with mobile devices.</li>
        <li>Added delivery of a simple non-database driven website for RHA online presence.</li>
        <li>Client hands free with all technical items including server configuration, administration and system support.</li>
      </ul>
    `,
  },
//   {
//     category: "BPO Services",
//     title: "Data Pharm",
//     description:
//       "Description Coming soon",
//     image: MapImg,
//     slug: "data-pharm",
//     content: `
//       <p>Content Coming Soon</p>
//     `,
//   },
//   {
//     category: "BPO Services",
//     title: "WINR",
//     description:
//       "Description Coming soon",
//     image: MapImg,
//     slug: "winr-bpo",
//     content: `
//       <p>Content Coming Soon</p>
//     `,
//   },
//   {
//     category: "EAF Services",
//     title: "MyOffers",
//     description:
//       "Description Coming soon",
//     image: MapImg,
//     slug: "my-offers-eaf",
//     content: `
//       <p>Content Coming Soon</p>
//     `,
//   },
//   {
//     category: "EAF Services",
//     title: "Every Day Health Group",
//     description:
//       "Description Coming soon",
//     image: MapImg,
//     slug: "everyday-health-group-eaf",
//     content: `
//       <p>Content Coming Soon</p>
//     `,
//   },
];
